import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AppHandler } from '../../app.handler';
import { IconComponent } from '../../../@ads/components';
import { PageTitleComponent } from '../../components/abstracts/page-title.component';
import { Types } from '../../../domain/types.domain';
import { AuthRepositoryInstruction } from '../../../builder/instructions/repositories/auth.repository.instructions';

@Component({
  selector: 'app-select-account-type',
  standalone: true,
  imports: [IconComponent],
  providers: [new AuthRepositoryInstruction()],
  templateUrl: './select-account-type.component.html',
  styleUrl: './select-account-type.component.scss',
})
export class SelectAccountTypeComponent extends PageTitleComponent(
  'Criar conta'
) {
  private readonly _router = inject(Router);
  private readonly _route = inject(ActivatedRoute);
  private readonly _appHandler = inject(AppHandler);
  private readonly _authRepository = inject(Types.AuthRepository);

  public selectedType = signal<'personal' | 'business' | null>(null);
  public allowUseCnpj = signal(false);

  get cityIdentity(): string {
    return this._route.snapshot.data['city']?.identidade ?? '';
  }

  async ngOnInit(): Promise<void> {
    this._appHandler.setLoading(false);
    this._appHandler.hideBackButton(true);

    const city = this._route.snapshot.data['city'];
    if (city?.index) {
      const config = await this._authRepository.getConfigByCityId(city.index);
      this.allowUseCnpj.set(config?.allowUseCnpj ?? false);
    }
  }

  selectType(type: 'personal' | 'business'): void {
    this.selectedType.set(type);
  }

  goBack(): void {
    this._router.navigate([`/${this.cityIdentity}`]);
  }

  continue(): void {
    if (!this.selectedType()) return;

    if (this.selectedType() === 'business') {
      this._router.navigate([`/${this.cityIdentity}/create-account-pj`]);
    } else {
      this._router.navigate([`/${this.cityIdentity}/create-account`]);
    }
  }
}
